import React, { useEffect, useState } from "react";
import CardPrimary from "../../components/card/CardPrimary";
import Search from "../../components/Search";
import camilaCabelloImg from "../../media/images/camila-cabello1.jpg";
import selenaGomezImg from "../../media/images/selena-gomez1.jpg";
import forYouImg from "../../media/images/albums/for-you.png";
import CardSecondary from "../../components/card/CardSecondary";
import { useNavigate } from "react-router-dom";

const SearchPage = () => {
  const navigate = useNavigate();
  const [search, setsearch] = useState("");
  useEffect(() => {
    if (search) {
      navigate(`/search/${search}`);
    } else {
      navigate("/search");
    }
  }, [search]);

  return (
    <div className="search-page">
      <Search
        placeholder="Search songs, artists, podcasts, playlists, etc..."
        value={search}
        onChange={(e) => setsearch(e.target.value)}
      />

      <div className="section">
        <h3>Your recent searches</h3>
        <div className="cards">
          <CardSecondary img={camilaCabelloImg} alt="camila cabello" text="Camila cabello" active />
          <CardSecondary img={selenaGomezImg} alt="selena gomez" text="Selena Gomez" active />
          <CardSecondary img={forYouImg} alt="for you" text="For you" active />
        </div>
      </div>

      <div className="section">
        <h3>Most popular searches</h3>
        <div className="cards">
          <CardSecondary img={camilaCabelloImg} alt="camila cabello" text="Camila cabello" active />
          <CardSecondary img={selenaGomezImg} alt="selena gomez" text="Selena Gomez" active />
          <CardSecondary img={forYouImg} alt="for you" text="For you" active />
          <CardSecondary img={camilaCabelloImg} alt="camila cabello" text="Camila cabello" active />
          <CardSecondary img={selenaGomezImg} alt="selena gomez" text="Selena Gomez" active />
          <CardSecondary img={forYouImg} alt="for you" text="For you" active />
          <CardSecondary img={camilaCabelloImg} alt="camila cabello" text="Camila cabello" active />
          <CardSecondary img={selenaGomezImg} alt="selena gomez" text="Selena Gomez" active />
          <CardSecondary img={forYouImg} alt="for you" text="For you" active />
        </div>
      </div>

      <div className="section">
        <h3>Popular artists</h3>
        <div className="cards">
          <CardSecondary img={camilaCabelloImg} alt="camila cabello" text="Camila cabello" active />
          <CardSecondary img={selenaGomezImg} alt="selena gomez" text="Selena Gomez" active />
        </div>
      </div>
    </div>
  );
};

export default SearchPage;
